// extracted by mini-css-extract-plugin
module.exports = {"value":"phone_group_list_value__ZaPmh","editing":"phone_group_list_editing__o2g3J"};